import React from 'react'
import PropTypes from 'prop-types'

import { required } from '@cred/shared/validations'
import Money from '@cred/react-basic-form-fields/hookForm/Money'

import Footer from 'multi-vertical/rate-table/components/filter-modal/footer'

import { minMaxBalanceAmount } from '../validations'
import styles from './styles.module.scss'

const noop = () => {}

/* eslint-disable indent */
const FilterForm = ({ invalid, update = noop, cancel, withFooter = false, control }) => {
  return (
    <>
      <div className={styles.filters}>
        <p className="bodySmall semiBold mb-8">Enter your balance amount:</p>
        <Money
          id="balanceAmount"
          name="balanceAmount"
          label="Balance amount"
          placeholder="Balance amount"
          control={control}
          controllerProps={{ rules: { validate: { required, minMaxBalanceAmount } } }}
          exposeValue
          icon={false}
        />
      </div>
      {withFooter && <Footer cancel={cancel} invalid={invalid} update={update} />}
    </>
  )
}

FilterForm.propTypes = {
  control: PropTypes.object.isRequired,
  cancel: PropTypes.func,
  update: PropTypes.func,
  invalid: PropTypes.bool,
  withFooter: PropTypes.bool,
}

export { FilterForm as FilterFormNoHoc }

export default FilterForm
